import type { ParecerDeGmud, RevisaoDePr } from '../../../types/gmud'

/**
 * Chegou código novo depois do parecer?
 *
 * O comitê só vê o parecer mais recente. Se um PR foi revisado ou mesclado depois de ele ser
 * emitido, o parecer não cobre a versão que vai a produção — e dizer isso na tela é a diferença
 * entre apoiar a decisão e induzi-la ao erro.
 *
 * Compara com os carimbos de CONTEÚDO — a revisão enviada e o merge do PR. Nunca com
 * `coletadoEm`: a sincronização o renova a cada 15 minutos mesmo sem nada mudar, e por ele todo
 * parecer estaria eternamente "defasado" um quarto de hora depois de emitido.
 *
 * @param parecer o parecer exibido
 * @param revisoes os PRs vinculados à solicitação
 * @returns true quando há revisão ou merge posterior à conclusão do parecer
 */
export function defasado(parecer: ParecerDeGmud | null, revisoes: RevisaoDePr[]): boolean {
  if (!parecer?.concluidoEm || parecer.situacao !== 'CONCLUIDA') {
    return false
  }
  const conclusao = Date.parse(parecer.concluidoEm)
  return revisoes.some((revisao) => {
    const sinais = [revisao.revisaoEnviadaEm, revisao.prMescladoEm]
    return sinais.some((sinal) => sinal != null && Date.parse(sinal) > conclusao)
  })
}
